import React, { useEffect, useState } from 'react';
import { useFormik } from 'formik';
import { useHistory, useParams } from 'react-router-dom';
import api from '../../services/api';
import {
  TextField, FormGroup, Container, Grid,
  Autocomplete,
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import 'dayjs/locale/pt';
import DeleteButton from '../../components/Buttons/DeleteButton';
import ReturnButton from '../../components/Buttons/ReturnButton';
import SaveButton from '../../components/Buttons/SaveButton';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import DateFnsUtils from '@date-io/date-fns';
import deLocale from 'date-fns/locale/pt-BR';
import * as Yup from 'yup';
import './styles.css';
import Progress from '../../components/Progress';
import { IconWithTooltipDate, IconWithTooltipSize, IconWithTooltipDescription } from './icons';
import { useDispatch } from 'react-redux';
import { setSnackbar } from '../../redux/snackbar';
import { setLoading } from '../../redux/loading';

const useStyles = makeStyles((theme) => ({
  root: {
    '& > *': {
      margin: theme.spacing(2),
    },
  },
}));

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

function Sample() {
  const [ponds, setPonds] = useState([]);
  const [cycles, setCycles] = useState([]);
  const [selectedPond, handlePond] = useState('');
  const [filterCycles, setFilterCycles] = useState([]);
  const [selectedCycles, handleCycle] = useState(null);
  const [selectedDate, handleDateChange] = useState(new Date());
  const [open, setOpen] = React.useState(false);
  const [openError, setOpenError] = React.useState(false);
  const [openProgress, setOpenProgress] = useState(false);
  const [disable, setDisable] = useState(false);
  const [locale, setLocale] = React.useState('pt');

  const dispatch = useDispatch();
  const classes = useStyles();
  const history = useHistory();
  const { id } = useParams();

  useEffect(() => {
    async function load() {
      // carrega os dados no seu devido campo caso tenha id, do contrário,
      // carrega o formulário vazio para cadastrar um novo
      setOpenProgress(true);
      const cycle_ = await api.get('/cycles');
      const pond_ = await api.get('/ponds');

      setPonds(pond_.data);
      setCycles(cycle_.data);
      setFilterCycles(cycle_.data);

      setOpenProgress(false);

      if (id) {
        const sample_ = await api.get(`/samples/${id}`); // padronizar requisicoes com um _ depois do nome (mas acho melhor antes)
        formik.setValues(sample_.data);
        handleDateChange(new Date(sample_.data.date));
        const { pond_id } = cycle_.data.find((cycle) => cycle.id === sample_.data.cycle_id);
        handlePond(pond_.data.find((pond) => pond.id === pond_id));
        setFilterCycles(cycle_.data.filter((cycle) => cycle.pond_id === pond_id));
        handleCycle(cycle_.data.find((cycle) => cycle.id === sample_.data.cycle_id));
      }
      setOpenProgress(false);
    }
    load();
  }, []);

  async function request(data) {
    // envia os dados para api salvar no banco
    setDisable(true);
    try {
      id
        ? await api.put(`/samples/${id}`, { ...data }).then((res) => {
          setOpen(true);
        })
        : await api.post('/samples', { ...data }).then((res) => {
          setOpen(true);
        });
      setTimeout(() => {
        history.push('/samples');
      }, 650);
    } catch (err) {
      setOpenError(true);

      setOpenError(false);
    }
    dispatch(setLoading(true));
  }

  const formik = useFormik({
    initialValues: {
      cycle_id: '',
      size: '',
      description: '',
      date: '',
    },
    validationSchema: Yup.object({
      size: Yup.number()
        .required('Campo Obrigatório')
        .min(0, 'Precisa ser acima de 0')
        .max(
          999999999,
          'Valor máximo ultrapassado. Diminua o tamanho da amostra',
        )
        .typeError(
          'O valor deve ser um número. Caso seja um número decimal utilize " . " ao invés de " , "',
        ),
    }),
    onSubmit: (values) => {
      dispatch(setLoading(true));
      values.date = selectedDate.toUTCString();
      values.cycle_id = selectedCycles.id;
      request(values);
    },
  });

  function handleClose(event, reason) {
    if (reason === 'clickaway') {
      return;
    }
    setOpenError(false);
  }

  const handleClickDel = async () => {
    await api.delete(`/samples/${id}`).then((res) => {
      setOpen(true);
    });
  };

  const success = () => {
    dispatch(
      setSnackbar(
        true,
        'success',
        'Ação Submetida com Sucesso!',
      ),
    );
    history.push('/samples');
  };

  const error = () => {
    dispatch(
      setSnackbar(
        true,
        'error',
        'Erro ao submeter ação! Tente novamente.',
      ),
    );
  };

  return (
    <Container>
      {openProgress ? <Progress /> : null}
      <form onSubmit={formik.handleSubmit}>
        <form className={classes.root}>
          <h2 className="title">Cadastro da Amostra</h2>

          <FormGroup>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <Autocomplete
                  noOptionsText="Sem opções"
                  name="pond_id"
                  options={ponds}
                  value={selectedPond}
                  getOptionLabel={(options) => options.description}
                                    // getOptionLabel={options => typeof options === 'string' ? options : options.description}
                  onChange={(p, v) => {
                    handlePond(v);
                    setFilterCycles(v ? cycles.filter((cycle) => (cycle.pond_id === v.id)) : cycles);
                    handleCycle();
                  }}
                  onBlur={formik.handleBlur}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Viveiro"
                      variant="outlined"
                    />
                  )}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <Autocomplete
                  noOptionsText="Sem opções"
                  name="cycle_id"
                  options={filterCycles}
                  value={selectedCycles}
                  getOptionLabel={(options) => options.description}
                  onChange={(p, v) => {
                    handleCycle(v);
                  }}
                  onBlur={formik.handleBlur}
                  renderInput={(params) => (
                    <TextField
                      required
                      {...params}
                      label="Ciclo"
                      variant="outlined"
                    />
                  )}
                />
              </Grid>
            </Grid>
          </FormGroup>
          <FormGroup>
            <TextField
              InputLabelProps={{ style: { pointerEvents: 'auto' } }}
              id="size"
              label={(
                <div>
                  Tamanho
                  {' '}
                  <IconWithTooltipSize />
                </div>
                              )}
              variant="outlined"
              name="size"
              type="number"
              value={formik.values.size}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched.size && formik.errors.size}
              helperText={
                                formik.touched.size && formik.errors.size && formik.errors.size
                            }
            />
          </FormGroup>
          <FormGroup>
            <TextField
              InputLabelProps={{ style: { pointerEvents: 'auto' } }}
              id="description"
              label={(
                <div>
                  Identificação (Opcional)
                  <IconWithTooltipDescription />
                </div>
                              )}
              variant="outlined"
              name="description"
              type="text"
              value={formik.values.description}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched.description && formik.errors.description}
              helperText={
                                formik.touched.description
                                && formik.errors.description
                                && formik.errors.description
                            }
            />
          </FormGroup>
          <FormGroup>
            <LocalizationProvider adapterLocale={deLocale} dateAdapter={DateFnsUtils}>
              <DatePicker
                InputLabelProps={{ style: { pointerEvents: 'auto' } }}
                label={(
                  <div>
                    Data
                    {' '}
                    <IconWithTooltipDate />
                  </div>
                                  )}
                name="date"
                variant="inline"
                inputVariant="outlined"
                invalidDateMessage="Data Inválida"
                value={selectedDate}
                onChange={(date) => handleDateChange(date)}
                onBlur={formik.handleBlur}
                format="dd/MM/yyyy"
                error={formik.touched.date && formik.errors.date}
                helperText={
                                    formik.touched.date && formik.errors.date && formik.errors.date
                                }
                                // inputFormat="DD/MM/YYYY"
                renderInput={(params) => <TextField {...params} />}
              />
            </LocalizationProvider>
          </FormGroup>
          <FormGroup>
            <Snackbar
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center',
              }}
              open={open}
              autoHideDuration={6000}
            >
              <Alert severity="success">Ação Submetida com Sucesso!</Alert>
            </Snackbar>
            <Snackbar
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center',
              }}
              open={openError}
              onClose={handleClose}
              autoHideDuration={3000}
            >
              <Alert severity="error">
                Erro ao submeter ação! Tente novamente.
              </Alert>
            </Snackbar>
          </FormGroup>
        </form>

        {open ? success() : null}
        {openError ? error() : null}

        <Grid container direction="row" justifyContent="space-between" alignItems="flex-end" className={classes.root}>
          <Grid item xs>
            <ReturnButton to="/samples" disabled={disable} />
          </Grid>

          {id != null
                        && (
                        <Grid item xs>
                          <DeleteButton
                            message="A exclusão dessa amostra leverá a exclusão dos objetos que dependem dela. Tem certeza que deseja excluir?"
                            onClick={() => handleClickDel()}
                            disabled={disable}
                          />
                        </Grid>
                        )}

          <Grid item xs>
            <SaveButton disabled={disable} />
          </Grid>
        </Grid>

      </form>
    </Container>
  );
}

export default Sample;
